import { CollectionInfo as CollectionInfoType } from 'globalTypes'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faInfo } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { plural } from '@lingui/macro'
import PreTitle from 'Root/App/PreTitle'
import { secondsToDuration } from 'lib/seconds-to-duration'
import filter from 'lodash/filter'
import isEmpty from 'lodash/isEmpty'
import join from 'lodash/join'

import styles from './index.module.css'

export type Props = CollectionInfoType

library.add(faInfo)

const CollectionInfo = (props) => {
  const filtered = filter([
    props.totalAudio &&
      plural(props.totalAudio, { one: '# audio', other: '# audio' }),
    props.totalImage &&
      plural(props.totalImage, { one: '# immagine', other: '# immagini' }),
    props.totalLink &&
      plural(props.totalLink, { one: '# link', other: '# link' }),
    props.totalPdf && plural(props.totalPdf, { one: '# pdf', other: '# pdf' }),
    props.totalQuiz &&
      plural(props.totalQuiz, { one: '# quiz', other: '# quiz' }),
    props.totalText &&
      plural(props.totalText, { one: '# testo', other: '# testi' }),
    props.totalVideo &&
      plural(props.totalVideo, { one: '# video', other: '# video' }),
  ])

  if (isEmpty(filtered) && !props.certificate_id) {
    return null
  }

  const shouldDisplayDuration = Boolean(props.duration && props.duration >= 60)

  function getDuration() {
    if (props.__typename === 'EventContent') {
      return secondsToDuration(
        (new Date(props.end)?.getTime() - new Date(props.start)?.getTime()) /
          1000
      )
    } else {
      return secondsToDuration(props.duration)
    }
  }

  return (
    <div className={styles.wrapper}>
      <div>
        <div className={props?.white ? styles.iconColWhite : styles.iconCol}>
          <FontAwesomeIcon icon={['fas', 'info']} transform={{ size: 20 }} />
        </div>
      </div>
      <div className="flex flex-col justify-start">
        <PreTitle
          className="my-auto text-gray-500"
          maxRows={shouldDisplayDuration ? 1 : 2}
        >
          {join(filtered, ' · ')}
        </PreTitle>
        <PreTitle className="text-gray-500 font-bold">{getDuration()}</PreTitle>
        {(props.slug === 'iEOTG-S4AEF' || props.slug === 'zfMK5-iDU0o') && (
          <PreTitle className="text-gray-500">
            Accesso illimitato ai contenuti
          </PreTitle>
        )}
      </div>
    </div>
  )
}

export default CollectionInfo
